import { createFileRoute, redirect } from '@tanstack/react-router';
import { readAuthToken, LOGIN_PATH } from '@noor/api';
import { WelcomePage } from '@/pages/welcome';

export const Route = createFileRoute('/welcome')({
  beforeLoad: () => {
    // Auth guard. `/welcome` is the post-login landing route and the target of
    // the bare `/` redirect, so it is the first authenticated screen a merchant
    // hits — an expired or absent token must bounce here rather than let the
    // launcher render and every sub-app query 401 one navigation later.
    //
    // Unlike the Eats screens this guard is NOT conditioned on `VITE_ENABLE_MSW`:
    // the launcher issues no requests at all, so the mock backend can't stand in
    // for a session the way it does for a data screen.
    if (!readAuthToken()) {
      // `redirect()` is TanStack Router's control-flow throw, not an Error.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: LOGIN_PATH });
    }
  },
  component: WelcomePage,
});
